export const maintenanceNotification = `<p>Please note we are currently performing maintenance. Services may be unavailable during this time. We apologize for any inconvenience.</p>`;
export const isDisplayingMaintenanceBanner = false;
